import { useSnapshot } from '@/hooks/useSnapshot'
import { KuroSiteOverviewSchema } from '@/modules/kuro-site/schema'
import { kuroSiteApi } from '@/modules/kuro-site/api'
import { DEFAULT_REFRESH_INTERVAL } from '@/lib/constants'

export function useKuroSiteOverview() {
  return useSnapshot(
    kuroSiteApi.overview(),
    'kuro-site',
    'overview',
    KuroSiteOverviewSchema,
    DEFAULT_REFRESH_INTERVAL
  )
}
